import { AttachPosition, Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class RecentlyDeletedTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.RECENTLY_DELETED;

	get id(): string {
		return TourId.RECENTLY_DELETED;
	}

	override get keyForPersistantDone(): string {
		return RecentlyDeletedTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				attachTo: () => {
					return this.el?.eq(0) || null;
				},
				attachPosition: AttachPosition.START,
				allowStacked: true,
			},
		];
	}
}
